'use strict'

import {
  SHOW_TOGGLE,
  LAYOUT
} from './mutation-type'
import Cookies from "js-cookie";

const mutations = {
  [SHOW_TOGGLE]: state => state.show = !state.show,
  [LAYOUT]: () => {
    Cookies.remove("healthadminId");
    Cookies.remove("healthadminName");
  }
}

export default mutations



// WEBPACK FOOTER //
// ./src/store/mutations.js